import React from 'react';
import useReveal from '../../hooks/useReveal';

/**
 * Envolve um bloco e aplica a animação de entrada ao entrar na viewport.
 * `delay` em ms escalona itens de uma mesma seção.
 */
function Reveal({ children, delay = 0, as: Tag = 'div', className = '', ...rest }) {
  const [ref, visible] = useReveal();

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? 'is-visible' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Reveal;
